class IdocCookies {
    constructor() {

        this.accettaFunzionali = null;
        this.accettaMarketing = null;
        this.cookieName = 'cookiepolicy';
        this.modalName = '#modal-cookies';
        this.modalOptionsName = '#modal-cookies-options';
        this.funzionaliSwitchName = '#cookieFunzionaliSwitch';
        this.marketingSwitchName = '#cookieMarketingSwitch';
        this.scriptsToInject = { funzionali: [], marketing: [] };
        this.allowedTypes = ['f', 'm'];
        this.isCookiePolicyPage = window.location.pathname == '/cookie-policy' || 
            window.location.pathname == '/privacy' || 
            window.location.pathname == '/messaggio/unsubscribe' ||
            window.location.pathname.indexOf('/unsubscribe/') === 0
            ? true : false;
        this.openedFromModal = false;
        let selfobj = this;

        $(document).ready(function () {

            var cookiePolicy = getCookie(selfobj.cookieName);
            var cookiePolicyAccepted = !!cookiePolicy ? true : false;
            var counter = 0;
            var limiter = 50;

            if (selfobj.isBot()) return;
            if (selfobj.isCookiePolicyPage && !cookiePolicyAccepted) return;

            if (!cookiePolicyAccepted) {
                $(selfobj.modalOptionsName).on('hidden.bs.modal', function (e) {
                    if(selfobj.openedFromModal) {
                        selfobj.openedFromModal = false;
                        $(selfobj.modalName).modal('show');
                        return;
                    }
                });
                return $(selfobj.modalName).modal({ backdrop: 'static', keyboard: false, show: true });
            }

            setTimeout(function waitPixel() {
                var pixelLoaded = document.getElementById('pixel-loader');
                if (!document.body.contains(pixelLoaded) && counter < limiter) {
                    counter++;
                    return setTimeout(waitPixel, 20);
                }
                selfobj.setScripts();
            }, 20);

        });

        /**
         * @param   script String     Contiene tutto lo script da iniettare come stringa
         * @param   type   String     F = funzionali, M = Marketing
         * @return  Void
         */
        this.injectScript = function (script, type, props) {
            var currentType = 'marketing';
            if (this.allowedTypes.indexOf(type) == -1) return;
            if (type == 'f') currentType = 'funzionali';

            this.scriptsToInject[currentType].push({ script: script, props: props });
        };

        this.showBanner = function () {
            this.setScripts();
            //$(this.modalName).modal({backdrop: 'static', keyboard: false, show: true});
            if($(this.modalName).is(':visible')) {
                $(this.modalName).modal('hide');
                this.openedFromModal = true;
            }
            $(this.modalOptionsName).modal('show');
        };

        this.confermaImpostazioni = function () {
            var cookieFunzionali = $(this.funzionaliSwitchName);
            var cookieMarketing = $(this.marketingSwitchName);
            this.accettaFunzionali = true; //cookieFunzionali.is(':checked');
            this.accettaMarketing = cookieMarketing.is(':checked');
            this.openedFromModal = false;
            $(this.modalOptionsName).modal('hide');

            if (!!!this.accettaMarketing) {
                //qui devo chiamare una url per aumentare il contatore
                $.post('/api/v1/cookie-removed', function (data, status) {
                    //console.debug("Data: " + data + "\nStatus: " + status);
                });
            }
            this.accetta();
        };

        this.accetta = function () {
            if (this.accettaMarketing == null) {
                this.tuttiOn();
            }

            var cookieAcceptDate = new Date().toISOString().slice(0, 10);
            var cookieValues = {
                funzionali: this.accettaFunzionali,
                marketing: this.accettaMarketing,
                dataAccettazione: cookieAcceptDate
            };
            var serialized = JSON.stringify(cookieValues);

            setCookie(this.cookieName, serialized, 730, '/', 'o');
            this.setScripts(true);
            $(this.modalName).modal('hide');

            loadCookies();
        };

        this.accettaTutti = function () {
            this.tuttiOn();
            this.openedFromModal = false;
            $(this.modalOptionsName).modal('hide');
            this.accetta();
        };

        this.tuttiOn = function () {
            this.accettaFunzionali = true;
            this.accettaMarketing = true;
        };

        this.setupAccepted = function () {
            var cook = getCookie(this.cookieName);
            var parse = JSON.parse(cook);
            if (parse) {
                this.accettaFunzionali = parse.funzionali;
                this.accettaMarketing = parse.marketing;
                $(this.funzionaliSwitchName).prop('checked', this.accettaFunzionali);
                $(this.marketingSwitchName).prop('checked', this.accettaMarketing);
            }
        };

        this.setScripts = function (bypassSetup) {
            if (!!!bypassSetup) {
                this.setupAccepted();
            }
            if (this.accettaFunzionali) {
                this.scriptsToInject.funzionali.forEach(this.insertScript);
            }
            if (this.accettaMarketing) {
                this.scriptsToInject.marketing.forEach(this.insertScript);
            }
        };

        this.insertScript = function (item, index) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = item.script;

            if (item.props) {
                if (item.props.defer) {
                    script.defer = true;
                }

                if (item.props.src) {
                    script.src = item.props.src;
                }
            }

            if (item?.props?.noscript) {
                //@todo da testare
                script = document.createElement('noscript');
                script.insertAdjacentHTML('beforeend', item.script);
            }

            document.body.appendChild(script);
        };

        this.isBot = function () {
            var botList = '(bot|crawl|spider|google|bing)';
            var reg = new RegExp(botList, 'i');
            var user = navigator.userAgent;
            var test = reg.test(user);
            return test;
        };
    }
}
window.cookieObj = new IdocCookies();
window.authUser = null;
loadCookies();

async function loadCookies()
{
    const onResult = await httpRequest(base_url + 'get-pixels', {url}, {showLoader: false});
    if (onResult.html) {
        $('body').append(onResult.html);
    }

    window.sessionID = onResult.sessionID;
    
    if (onResult.authToken) {
        window.authUser = onResult.user;
        window.authToken = onResult.authToken;
    }
    
    if (onResult.favorites) {
        var favoritesEvent = new CustomEvent('updatefavs', {detail: onResult.favorites, bubbles: true});
        window.dispatchEvent(favoritesEvent);

        //se mi arrivano da qui vuol dire che sono loggato e sto usando dati reali. pulisco i remasugli del localstorage
        localStorage.removeItem('favorites');
    }

    if(window.authUser) {
        $('#noAuthMenu').hide();
        $('#authMenu').removeClass('d-none');
        $('#authMenu li a').each(function() {
            $(this).attr('href', $(this).data('href'));
        })
        $('#collaboraBtn').hide();
        $('#collaboraBtnCentro').hide();

        if (getCookie('adminCrossLogin')) {
            $('#navbarMenu ul:first').prepend(`
            <li class="nav-item">
            <a href="/area_utente/logout" rel="nofollow" class="nav-link">
            Ciao ${getCookie('adminCrossLogin')}, hai effettuato l'accesso con le credenziali dell'utente ${window.authUser.fullName}.
            </a>
            </li>
            `)
        }

        window.updateUserBadges();
    }

    initBaseAppFrontend();
}
